export var ProjectTabsEnum;
(function (ProjectTabsEnum) {
    ProjectTabsEnum["SUMMARY"] = "summary";
    ProjectTabsEnum["ARCHIVED"] = "archived";
    ProjectTabsEnum["DOCUMENTS"] = "documents";
    ProjectTabsEnum["USERS"] = "users";
})(ProjectTabsEnum || (ProjectTabsEnum = {}));
